export default {
  namespaced: true,
  state: {
    url: `/api/assets`,
    assets: [],
  },
  getters: {
    getAssets: (state) => state.assets,
    getAssetById: (state) => (id) =>
      state.assets.find((asset) => asset._id === id),
  },
  mutations: {
    setAssets: (state, data) => {
      state.assets = _.map(data, (item) => {
        return item;
      });
    },
    insertAsset: (state, data) => {
      if (Array.isArray(data)) {
        state.assets = state.assets.concat(data);
      } else {
        state.assets.push(data);
      }
    },
    updateAssetById: (state, { id, data }) => {
      let index = state.assets.findIndex((asset) => asset._id === id);
      // delete or update item of array
      if (data.is_archived) {
        state.assets.splice(index, 1);
      } else {
        state.assets[index] = _.assign(state.assets[index], data);
      }
    },
  },
  actions: {
    async getAssets({ commit, state }) {
      try {
        let res = await axios.get(state.url);
        commit("setAssets", res.data);
      } catch (e) {
        throw e;
      }
    },
    async getAssetById({ commit, state }, id) {
      try {
        let res = await axios.get(`${state.url}/${id}`);
        commit("insertAsset", res.data);
      } catch (e) {
        throw e;
      }
    },
    async createAsset({ commit, state }, { formData, config }) {
      try {
        let res = await axios.post(state.url, formData, config);
        commit("insertAsset", res.data);
        return res.data.url;
      } catch (e) {
        throw e;
      }
    },
    async updateAssetById({ commit, state }, { id, setObj }) {
      try {
        await axios.put(`${state.url}/${id}`, setObj);
        commit("updateAssetById", { id: id, data: setObj });
      } catch (e) {
        throw e;
      }
    },
    async patchAssetById({ commit, state }, { id, setObj }) {
      try {
        await axios.patch(`${state.url}/${id}`, setObj);
        commit("updateAssetById", { id: id, data: setObj });
      } catch (e) {
        throw e;
      }
    },
  },
};
